var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.241,
    height: 20.957,
    viewBox: "0 0 12.241 20.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11519",
    "data-name": "Group 11519",
    transform: "translate(-187.757 -89.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M157.427,261.7c-.142-.243-.271-.469-.4-.7-.669-1.173-1.345-2.34-2-3.521a43.448,43.448,0,0,1-2.45-5.1,21.065,21.065,0,0,1-1.068-3.455,10.36,10.36,0,0,1-.232-2.985,5.206,5.206,0,0,1,1.535-3.456,5.627,5.627,0,0,1,1.939-1.189,8.925,8.925,0,0,1,2.451-.544,3.928,3.928,0,0,1,.816.056,8.871,8.871,0,0,1,1.853.435,5.59,5.59,0,0,1,2.2,1.368,4.9,4.9,0,0,1,1.223,2.282,7.64,7.64,0,0,1,.169,2.374,15.717,15.717,0,0,1-.859,3.941,36.563,36.563,0,0,1-2.432,5.518c-.751,1.407-1.537,2.8-2.308,4.191Zm-.02-2.2c.027-.04.043-.061.056-.084.466-.839.94-1.673,1.4-2.516a42.058,42.058,0,0,0,2.431-5.215,16.769,16.769,0,0,0,1.08-4.264,6.866,6.866,0,0,0-.108-2.212,3.746,3.746,0,0,0-1.758-2.463,5.881,5.881,0,0,0-1.949-.728,4.691,4.691,0,0,0-1.77-.114,8.066,8.066,0,0,0-2.167.646,3.823,3.823,0,0,0-2.108,2.519,6.556,6.556,0,0,0-.151,2.351,13.113,13.113,0,0,0,.438,2.254,27.745,27.745,0,0,0,1.676,4.365c.764,1.626,1.629,3.195,2.525,4.747Z",
    transform: "translate(36.509 -151.223)",
    fill: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M212.521,301.561a1.916,1.916,0,1,1,1.891-1.912A1.9,1.9,0,0,1,212.521,301.561Z",
    transform: "translate(-18.621 -204.239)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.548d803b1407c4ac43fad8a6a933c4d9.svg";
export { ForwardRef as ReactComponent };